import type { FC } from 'react';
import { useEffect } from 'react';

import { Box, Col } from '@opendoor/bricks-next';

import { useTOSContext } from './TOSProvider';

/**
 * FullScreenLoader - use this instead of directly importing from bricks to hide the TOS modal on load
 */
export const FullScreenLoader = () => {
  const { forceHideTOSModal } = useTOSContext();

  // DO NOT REMOVE: Do not show the TOS modal on this page
  useEffect(() => {
    // set this as false on the initial render - so it doesn't show it on this page
    forceHideTOSModal(true);
    return () => {
      // allow the TOS component to be shown when we unmount
      forceHideTOSModal(false);
    };
  }, [forceHideTOSModal]);

  return <Loader />;
};

/**
 * Loader that fills the entire screen with a pulsing Opendoor logo
 */
const Loader: FC = () => (
  <Col
    data-testid="full-screen-loader"
    justifyContent="center"
    alignItems="center"
    p="$10x"
    backgroundColor="$backgroundAccentBrand"
    $platform-web={{
      width: '100vw',
      height: '100dvh',
    }}
  >
    <Box className="full-screen-loader-pulse" display="block" $platform-web={{ color: '#FFF' }}>
      <Logo />
    </Box>
  </Col>
);

const Logo = () => (
  <svg width="100%" height={100} viewBox="0 0 17 24" fill="none">
    <title>Opendoor Logo</title>
    <path
      data-testid="opendoorOLogo"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.145 9.2703C12.145 3.45463 11.1453 1.04394 8.39652 1.04394C5.97245 1.04394 4.74795 2.73386 4.74795 8.59936C4.74795 14.3902 5.6976 16.7761 8.49644 16.7761C10.9704 16.7761 12.145 15.1108 12.145 9.2703ZM0 9.12128C0 2.58475 4.52311 0 8.54644 0C12.8446 0 16.8929 2.55998 16.8929 8.7236C16.8929 15.3097 12.3699 17.82 8.34642 17.82C4.04834 17.82 0 15.0862 0 9.12128ZM16.0108 23.0785C15.6006 22.5374 14.0208 20.453 14.0208 20.453C13.8726 20.2575 13.6186 20.1394 13.346 20.1394H3.54692C3.27434 20.1394 3.02035 20.2575 2.87212 20.453L0.882439 23.0781C0.819318 23.1614 0.785826 23.2583 0.785826 23.3574V23.7581C0.785826 23.8917 0.894706 24 1.02906 24H15.8638C15.9982 24 16.1071 23.8917 16.1071 23.7581V23.3574C16.1071 23.2583 16.0739 23.1617 16.0108 23.0785Z"
      fill="#fff"
    />
  </svg>
);
